import { render, staticRenderFns } from "./NotAccordingToModalView.vue?vue&type=template&id=42752b21&scoped=true&"
import script from "./NotAccordingToModalView.vue?vue&type=script&lang=js&"
export * from "./NotAccordingToModalView.vue?vue&type=script&lang=js&"
import style0 from "./NotAccordingToModalView.vue?vue&type=style&index=0&id=42752b21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42752b21",
  null
  
)

export default component.exports